import React from 'react'

const ClientSucessStoryContainer = ({ containerObject, dataZone, templateName, contentId }) => {
    var content = containerObject;
     var testimonialItem = containerObject.ClientSucessStoryContainer
    

    return (
        // <!--testimonial section start-->
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row `}>
            <section class="testimonial-section ptb-40 bg-light">
                <div class="container">
                    <div class="row justify-content-center align-content-center">
                        <div class="col-md-10 col-lg-6">
                            <div class="section-heading text-center">
                                <h4 class="h5 text-primary" dangerouslySetInnerHTML={{ __html: content.containerTitle }}></h4>
                                <h2 dangerouslySetInnerHTML={{ __html: content.containerSubTitle }}></h2>
                                <p dangerouslySetInnerHTML={{ __html: content.containerBody }}></p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="position-relative w-100">
                                <div class="swiper customSwiper">
                                    <div class="swiper-wrapper">
                                     

                                    {testimonialItem ? testimonialItem.map((item)=>{
                                      
                                       return(
                                         <div class="swiper-slide">
                                       <div class="tab-pane fade active show" id="testimonial-tab-1" role="tabpanel">
                                            <div class="row align-items-center justify-content-between">
                                                <div class="col-lg-6 col-md-6">
                                                    <div class="testimonial-tab-content mb-5 mb-lg-0 mb-md-0" style={{textAlign: "left"}}>
                                                        <img src={`${item.quoteImage ? item.quoteImage : ""}`} alt="testimonial quote" width="65" class="img-fluid mb-32" />
                                                        <div class="blockquote-title-review mb-4" >
                                                            <h3 class="mb-0 h4 fw-semi-bold">{item.attributes.header}</h3>
                                                            <ul class="review-rate mb-0 list-unstyled list-inline">
                                                                <li class="list-inline-item"><i
                                                                    class="fas fa-star text-warning"></i>
                                                                </li>
                                                                <li class="list-inline-item"><i
                                                                    class="fas fa-star text-warning"></i>
                                                                </li>
                                                                <li class="list-inline-item"><i
                                                                    class="fas fa-star text-warning"></i>
                                                                </li>
                                                                <li class="list-inline-item"><i
                                                                    class="fas fa-star text-warning"></i>
                                                                </li>
                                                                <li class="list-inline-item"><i
                                                                    class="fas fa-star text-warning"></i>
                                                                </li>
                                                            </ul>
                                                        </div>

                                                        <blockquote class="blockquote" >
                                                            <p>{item.attributes.body}</p>
                                                        </blockquote>
                                                        <div class="author-info mt-4" >
                                                            <h6 class="mb-0">{item.attributes.authourname}</h6>
                                                            <span>{item.attributes.authourposition}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-5 col-md-6">
                                                    <div class="author-img-wrap pt-5 ps-5">
                                                        
                                                            <div class="testimonial-video-wrapper position-relative">
                                                            <img src={`${item.mainImage ? item.mainImage : ""}`} class="img-fluid rounded-custom shadow-lg" alt="testimonial author" />
                                                            <div class="customer-info text-white d-flex align-items-center">
                                                            </div>
                                                            <div class="position-absolute bg-secondary-dark z--1 dot-mask dm-size-16 dm-wh-350 top--40 left--40 top-left"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                         </div>
                                         )
                                        })
                                        :"" } 

                                    </div>
                                </div>
                                <span class="swiper-button-next"></span>
                                <span class="swiper-button-prev"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>

    )
}
export default ClientSucessStoryContainer